import React, {CSSProperties} from "react";
import styled from "styled-components";

export default function ProgressBar(props: {
    progress?: number
    className?: string
    style?: CSSProperties
}) {
    return <ProgressBarWrapper style={props.style} className={props.className}>
        <ProgressInner style={{width: `${(props.progress || 0) * 100}%`}}/>
    </ProgressBarWrapper>
}

const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 20px;
  border-radius: 10px;
  background-color:#2152BB;
  position: relative;
  overflow: hidden;
`
const ProgressInner = styled.div`
  height: 20px;
  border-radius: 10px;
  background: linear-gradient(270deg, #2E8EFE 0%, #DD00F2 100%);
  position: absolute;
  left: 0;
  top: 0;
`